import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { InputPanel, InputPassword, InputTextBox } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues } from '@camelot/utils';

import {
  MailSyncConfiguration,
  MailSyncConfigurationCreationPayload,
  MailSyncConfigurationModifierPayload,
} from '../dto/mail-sync-configuration';

enum EMailSyncConfigFormFields {
  clientTenantId = 'clientTenantId',
  clientId = 'clientId',
  clientSecret = 'clientSecret',
  name = 'name',
}

@Injectable({
  providedIn: 'root',
})
export class CamMailSyncConfigFormService {
  public getMailSyncConfigForm(mailSyncConfiguration: MailSyncConfiguration | null) {
    return [
      new InputPanel({
        key: 'panel',
        label: 'mail-sync-config.form.title',
        contentClass: 'highlight-title g-space-md',
        children: [
          new InputTextBox({
            key: EMailSyncConfigFormFields.clientId,
            value: mailSyncConfiguration?.clientId,
            label: 'mail-sync-config.form.clientId',
            validators: [Validators.required],
          }),
          new InputPassword({
            alwaysHidden: true,
            key: EMailSyncConfigFormFields.clientSecret,
            value: mailSyncConfiguration?.clientSecret,
            label: 'mail-sync-config.form.clientSecret',
            validators: [Validators.required],
          }),
          new InputTextBox({
            key: EMailSyncConfigFormFields.clientTenantId,
            value: mailSyncConfiguration?.clientTenantId,
            label: 'mail-sync-config.form.clientTenantId',
            validators: [Validators.required],
          }),
          new InputTextBox({
            key: EMailSyncConfigFormFields.name,
            value: mailSyncConfiguration?.name,
            label: 'mail-sync-config.form.name',
            validators: [Validators.required],
          }),
        ],
      }),
    ];
  }

  public mailSyncConfigCreateFormatForm(data: any): MailSyncConfigurationCreationPayload {
    return {
      clientId: data[EMailSyncConfigFormFields.clientId] ?? null,
      clientSecret: data[EMailSyncConfigFormFields.clientSecret] ?? null,
      clientTenantId: data[EMailSyncConfigFormFields.clientTenantId] ?? null,
      name: data[EMailSyncConfigFormFields.name] ?? null,
    };
  }
  public mailSyncConfigUpdateFormatForm(
    data: any,
    mailSyncConfig: MailSyncConfiguration
  ): Partial<MailSyncConfigurationModifierPayload> {
    const modifiedData = getModifiedValues(data, mailSyncConfig);
    return {
      ...{
        clientId: data[EMailSyncConfigFormFields.clientId] ?? null,
        clientSecret: data[EMailSyncConfigFormFields.clientSecret] ?? null,
        clientTenantId: data[EMailSyncConfigFormFields.clientTenantId] ?? null,
        name: data[EMailSyncConfigFormFields.name] ?? null,
      },
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
